import React from 'react';

/**
 * UniversityVerifiedBadge
 * Renders:
 * 1. Official Partner Badge: Dakhla indigo starburst badge with crisp white checkmark.
 * 2. Public Directory Badge: Crisp slate globe icon for non-partner listings.
 */
const UniversityVerifiedBadge = ({ 
  isPartner = false, 
  className = "h-5 w-5", 
  showTooltip = true,
  showNonPartnerIcon = true 
}) => {
  if (isPartner) {
    return (
      <span 
        title={showTooltip ? "Official Partner Institution" : undefined}
        className="inline-flex items-center justify-center shrink-0 align-middle select-none"
      >
        <svg 
          className={`shrink-0 ${className}`} 
          viewBox="0 0 24 24" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Dakhla Brand Starburst / Verified Badge Background */}
          <path
            d="M12 2L14.4 3.9L17.4 3.6L18.8 6.2L21.4 7.4L21.2 10.4L23 12.5L21.2 14.6L21.4 17.6L18.8 18.8L17.4 21.4L14.4 21.1L12 23L9.6 21.1L6.6 21.4L5.2 18.8L2.6 17.6L2.8 14.6L1 12.5L2.8 10.4L2.6 7.4L5.2 6.2L6.6 3.6L9.6 3.9L12 2Z"
            fill="#393FEE"
          />
          {/* Crisp White Checkmark */}
          <path
            d="M8.1 12.9L10.5 15.3L15.5 10.3"
            stroke="white"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    );
  }

  if (!showNonPartnerIcon) {
    return null;
  }

  return (
    <span 
      title={showTooltip ? "Public Information Listing" : undefined}
      className="inline-flex items-center justify-center shrink-0 align-middle select-none"
    >
      <svg 
        className={`shrink-0 ${className} text-slate-400`} 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Crisp Globe Icon without container disc */}
        <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.6" />
        <path d="M3.5 12H20.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        <path d="M12 3.5C14.8 6.2 16.2 9.1 16.2 12C16.2 14.9 14.8 17.8 12 20.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        <path d="M12 3.5C9.2 6.2 7.8 9.1 7.8 12C7.8 14.9 9.2 17.8 12 20.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      </svg>
    </span>
  );
};

export default UniversityVerifiedBadge;
